import usePostPaymentOrderTransaction from '../../../../services/hookService/postPaymentOrderTransaction/usePostPaymentOrderTransaction';
import usePostPaymentStoreOrderTransaction from '../../../../services/hookService/postPaymentStoreOrderTransaction/usePostPaymentStoreOrderTransaction';
import {
  PaymentMethodValues,
  paymentTypeMap,
  TransactionTypesChoices,
} from '../utils/helpers';

export function usePostPaymentTransaction({
  transactionType,
  paymentType,
  orderGuid,
  storeOrderGuid,
  enabled = true,
  handleAfterSuccess,
}: {
  transactionType?: TransactionTypesChoices;
  paymentType?: PaymentMethodValues;
  orderGuid?: string;
  storeOrderGuid?: string;
  enabled?: boolean;
  handleAfterSuccess?: (data: unknown) => void;
}) {
  const orderMutation = usePostPaymentOrderTransaction(handleAfterSuccess);

  const storeOrderMutation =
    usePostPaymentStoreOrderTransaction(handleAfterSuccess);

  const emptyMutation = {
    mutate: (_: any) => {},
    isLoading: false,
  };

  let activeMutation = emptyMutation;

  switch (transactionType) {
    case TransactionTypesChoices.ORDER:
      activeMutation = orderMutation;
      break;

    case TransactionTypesChoices.STORE_ORDER:
      activeMutation = storeOrderMutation;
      break;

    default:
      activeMutation = emptyMutation;
  }

  const mutate = () => {
    if (!enabled || !paymentType) return;
    const mappedPaymentType = paymentTypeMap[paymentType];

    if (transactionType === TransactionTypesChoices.ORDER && orderGuid) {
      activeMutation.mutate({
        order: orderGuid,
        payment_type: mappedPaymentType,
      });
    }

    if (
      transactionType === TransactionTypesChoices.STORE_ORDER &&
      storeOrderGuid
    ) {
      activeMutation.mutate({
        store_order: storeOrderGuid,
        payment_type: mappedPaymentType,
      });
    }
  };

  return {
    mutate,
    isLoading: activeMutation.isLoading,
  };
}
